import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
export type Portfolios =  {
    portfolioId: string
    organisationId: string
    portfolioName: string
    programs: Program[]
  }
  
export interface Program {
    programId: string
    portfolioId: string
    programName: string
  }
  
export type PortfoliosResponse = ResponseType<{programs:Program[],portfolios:Portfolios[]}>;

function useAllPortfoliosQuery() {
  return useQuery<
    AxiosResponseAndError<PortfoliosResponse>["response"],
    AxiosResponseAndError<PortfoliosResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.portfolios],
    queryFn: async () => await ApiRequest.get(requestURLs.project + "/portfolios"),
    enabled: true,
  });
}

export default useAllPortfoliosQuery;
